import * as React from 'react';
import { observer } from 'mobx-react';

import { Input } from 'shared/newComponents/form';
import {
  TranslationString,
  useTypedTranslation
} from 'shared/entities/localization';
import DomainField from 'shared/newComponents/form/DomainField';
import CabinetCreationStore from 'stores/cabinetCreationStore';
import { useEnterClickEventListener } from 'shared/entities/common/hooks';
import { InputSize } from 'shared/newEntities/components/Input';

type Props = {
  cabinetCreationStore: CabinetCreationStore;
  nameLabel?: TranslationString | string;
  namePlaceholder?: TranslationString | string;
  withBottomLabel?: boolean;
};

const CabinetCreationForm: React.FC<Props> = ({
  cabinetCreationStore,
  nameLabel,
  namePlaceholder,
  withBottomLabel
}: Props) => {
  const { t } = useTypedTranslation('newContainers');
  const ref = React.useRef<HTMLInputElement | null>(null);

  useEnterClickEventListener({
    handler: cabinetCreationStore.generateDomainOnEnter,
    getElement: () => ref.current
  });

  return (
    <>
      <Input
        ref={ref}
        size={InputSize.xl}
        label={nameLabel ?? t('CabinetCreationForm.name.label')}
        placeholder={
          namePlaceholder ?? t('CabinetCreationForm.name.placeholder')
        }
        value={cabinetCreationStore.cabinetEditModel.name.value}
        onChange={cabinetCreationStore.cabinetEditModel.name.changeValue}
        onBlur={cabinetCreationStore.validateName}
        error={cabinetCreationStore.cabinetEditModel.name.error}
        bottomLabel={
          withBottomLabel
            ? t('CabinetCreationForm.name.bottomLabel')
            : undefined
        }
      />
      <DomainField
        className="form-item form-item_m"
        value={cabinetCreationStore.cabinetEditModel.domain.value}
        onChange={cabinetCreationStore.cabinetEditModel.changeDomain}
        error={cabinetCreationStore.cabinetEditModel.domain.error}
        onBlur={cabinetCreationStore.cabinetEditModel.validateDomain}
        label={(t) =>
          t('CabinetCreationForm.domain.label', { ns: 'newContainers' })
        }
        placeholder={(t) =>
          t('CabinetCreationForm.domain.placeholder', { ns: 'newContainers' })
        }
        disabledGeneration={cabinetCreationStore.cabinetEditModel.isNameEmpty}
        onGenerateDomain={cabinetCreationStore.generateDomain}
        generatingDomainLoading={
          cabinetCreationStore.generatingDomainStage.isLoading
        }
        showGenerationButton={cabinetCreationStore.showedGenerationButton.value}
        disabled={cabinetCreationStore.generatingDomainStage.isLoading}
      />
    </>
  );
};

export default observer(CabinetCreationForm);
